import { createStyles, makeStyles } from '@material-ui/core';
import { Sizes } from '../../../../../styles/sizes';
import { colorVariables } from '../../../../../styles/colorVariables';

export const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      padding: '10px 16px',
      border: '1px solid rgba(152, 165, 183, 0.15)',
      background: 'rgba(152, 165, 183, 0.1)',
      marginBottom: '12px',
      borderRadius: 8,
      marginRight: 10,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 20,
    },
    title: {
      fontSize: '12px',
      fontWeight: 700,
      textTransform: 'uppercase',
      color: colorVariables.navy,
    },
    input: {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#ced4da',
        },
        '&:hover fieldset': {
          borderColor: '#ced4da',
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.primary.main,
        },
      },
    },
    deleteIcon: {
      color: '#EA6363',
      fontSize: 16,
      cursor: 'pointer',
      height: 16,
      width: 16,
    },
    label: {
      fontSize: 12,
      fontWeight: 400,
      color: colorVariables.grey80,
      marginTop: 10,
    },
    cutoffTime: {
      paddingTop: 10,
      '& div': {
        width: '100%'
      }
    }
  }),
);
